export default `<div>
    <ul
        class="datalist"
        role="listbox"
        aria-label="Select options"
        part="listbox"
        tabindex="-1"
    >
        <li class="no-options" role="status" aria-live="polite">
            No options available
        </li>
    </ul>
    <div
        class="datalist-live-region sr-only"
        role="status"
        aria-live="polite"
        aria-atomic="true"
    ></div>
</div>

<style>
    /* ToDo: Border radius or not, design shows radius but think it will look weird*/
    :host {
        display: block;
        position: relative;
        width: 100%;
        font-family: Asap, sans-serif;
    }

    .datalist {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        padding: 0;
    }

    .datalist.disabled {
        color: var(--svea-datalist-disabled-color, #949494);
        cursor: not-allowed;
    }

    .datalist.disabled .checkbox {
        border-color: var(--svea-datalist-disabled-border-color, #cbcbcb);
    }

    .datalist.disabled .option.selected .checkbox {
        background-color: var(
            --svea-datalist-disabled-background-color,
            #cbcbcb
        );
    }

    .option {
        position: relative;
        display: inline-flex;
        align-items: center;
        column-gap: 0.75rem;
        padding: 0.5rem 0.75rem;
        cursor: pointer;
        border-radius: 0.375rem;
    }

    .option.focused {
        background-color: #e8f6f9;
    }

    .datalist:not(.disabled) .option:hover {
        background-color: #00699a0d;
    }

    .datalist:not(.disabled) .option:focus {
        outline: 2px solid #00699a;
        outline-offset: -2px;
    }

    .checkbox {
        width: 1.25rem;
        min-width: 1.25rem;
        height: 1.25rem;
        border: 2px solid #00699a;
        border-radius: 0.25rem;
    }

    .datalist:not(.multiple) .option.selected {
        background-color: #e8f6f9;
    }

    .datalist:not(.multiple) .option.selected::after {
        content: url('data:image/svg+xml,<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.2677 0.513962C15.0615 0.365482 14.8049 0.30499 14.5541 0.34574C14.3034 0.386491 14.079 0.52505 13.9305 0.731184L4.96331 13.2402L1.97 10.2421C1.85115 10.1229 1.70302 10.0372 1.54051 9.99339C1.37799 9.94963 1.20682 9.94965 1.04421 9.99308C0.88163 10.0366 0.733361 10.1222 0.614318 10.2412C0.495275 10.3602 0.409653 10.5083 0.366068 10.671C0.322484 10.8336 0.322477 11.0049 0.366039 11.1675C0.409601 11.3301 0.495193 11.4783 0.61422 11.5973L4.40617 15.394C4.5058 15.4899 4.62471 15.5636 4.75498 15.61C4.88525 15.6563 5.02389 15.6742 5.16166 15.6627C5.29943 15.6512 5.43318 15.6104 5.55398 15.5432C5.67479 15.4759 5.77988 15.3836 5.86226 15.2726L15.4881 1.84975C15.6356 1.64324 15.6952 1.38671 15.6539 1.13629C15.6126 0.885873 15.4737 0.6621 15.2677 0.513962Z" fill="%23434343"/></svg>');
        position: absolute;
        right: 1rem;
    }

    .option.selected .checkbox {
        background-color: #00699a;
        background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10" viewBox="0 0 14 10" fill="none"><path d="M1 5L5 9L13 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        background-repeat: no-repeat;
        background-position: center;
    }

    .no-options {
        padding: 0.5rem 0.75rem;
        color: var(--svea-datalist-no-options-color, #949494);
        text-align: center;
    }

    .remove-btn {
        position: absolute;
        top: 50%;
        right: 0.5rem;
        transform: translateY(-50%);
        border: 0;
        background: transparent;
        color: var(--svea-datalist-remove-btn-color, #949494);
        font-size: 1rem;
    }

    .remove-btn:hover {
        color: var(--svea-datalist-remove-btn-color-hover, #343434);
        cursor: pointer;
    }

    .sr-only {
        clip: rect(0 0 0 0);
        clip-path: inset(100%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
    }
</style>
`